import { applicationSave, applicationFetch, applicationUpdate, applicationFetchAll } from './applicationActions';
import School from '../api/school';

export const fetchSchools = applicationFetchAll(School);
export const fetchSchool = applicationFetch(School);
export const saveSchool = applicationSave(School);
export const updateSchool = applicationUpdate(School);
